// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"516f0304","119":"776e87eb","120":"16cc53bc","587":"61bddc6a","767":"1f70ba1e","787":"f5b783fb"}[chunkId] + ".chunk.js";
};